import { createStore, createHook } from '@atlassian/react-sweet-state';
import type { State } from '../../common/types';
import * as actions from './actions';

type Actions = typeof actions;

export const initialState: State = {
	sprint: null,
	estimation: null,
	dataLoadedOnce: false,
	dataVariables: {
		sprintId: null,
		estimation: null,
	},
};

export const makeStore = (name: string) =>
	createStore<State, Actions>({
		initialState,
		actions,
		name,
	});

export const makeUseFilters = (name: string) => createHook(makeStore(name));
